module.exports = require("addons-scanner-utils/const");